import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

import {
  Direction,
  HorizontalPosition,
  IButtonContainer,
  ILockedAspectRatio,
  ITileSizeable,
  ITileStyleable,
  TileSize,
} from './types';

function getWrapperHeight({ tileSize, lockedAspectRatio }: ITileSizeable & ILockedAspectRatio) {
  if (lockedAspectRatio) {
    return 'auto';
  }

  const titleSizeMap = {
    [TileSize.FULL]: 266,
    [TileSize.HALF]: 300,
  };
  return titleSizeMap[tileSize] ?? 'auto';
}

export const Wrapper = ({
  additionalPadding,
  hasBorder,
  hasBoxShadow,
  tileSize,
  lockedAspectRatio,
  style,
  ...props
}: BoxProps & ITileSizeable & ITileStyleable & ILockedAspectRatio) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.wrapper,
      {
        borderWidth: hasBorder ? 2 : 0,
        height: getWrapperHeight({ tileSize, lockedAspectRatio }),
        padding: additionalPadding ? Number.parseFloat(additionalPadding) || 0 : 0,
      },
      hasBoxShadow && styles.shadow,
      style,
    ],
  });

export const Content = ({ tileSize, style, ...props }: BoxProps & ITileSizeable) =>
  React.createElement(Box, {
    ...props,
    style: [styles.content, { padding: tileSize === TileSize.HALF ? 12 : 16 }, style],
  });

export const ButtonContainer = ({
  $direction,
  buttonPosition,
  isShowingTwoButtons,
  style,
  ...props
}: BoxProps & IButtonContainer) => {
  const horizontalPositionToFlexMap = {
    [HorizontalPosition.LEFT]: 'flex-start' as const,
    [HorizontalPosition.CENTER]: 'center' as const,
    [HorizontalPosition.RIGHT]: 'flex-end' as const,
  };
  return React.createElement(Box, {
    ...props,
    style: [
      styles.buttonContainer,
      {
        flexDirection: $direction === Direction.REVERSE ? 'row-reverse' : 'row',
        justifyContent: isShowingTwoButtons
          ? 'space-between'
          : horizontalPositionToFlexMap[buttonPosition],
      },
      style,
    ],
  });
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: primitive.$mayoEggWhite,
    borderColor: primitive.$white,
    borderStyle: 'solid',
    margin: 0,
    width: '100%',
  },
  shadow: {
    elevation: 2,
    shadowColor: primitive.$black,
    shadowOpacity: 0.15,
    shadowRadius: 2,
  },
  content: {
    height: '100%',
    justifyContent: 'space-between',
  },
  buttonContainer: {
    flexDirection: 'row',
  },
});
